<template>
    <div class="soc-sara-sidebar" :class="{ 'mobile-nav': isMobile, open: isMobile && mobileStore.isMobileNavOpen }">
        <!-- Mobile Header -->
        <div v-if="isMobile">
            <button class="close-button" @click="mobileStore.closeMobileNav">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <div class="sidebar-title">
            <h1>SARA</h1>
        </div>
        <div class="grid grid-cols-2 gap-3 mb-2">
            <div>
                <p class="number-text">450</p>
                <p class="sub-heding-text text-zinc-400">Active Drivers</p>
            </div>
            <div>
                <p class="number-text">95%</p>
                <p class="sub-heding-text text-zinc-400">Coverage</p>
            </div>
            <div>
                <p class="number-text">1,500</p>
                <p class="sub-heding-text text-zinc-400">Scannable Sites</p>
            </div>
            <div>
                <p class="number-text">12</p>
                <p class="sub-heding-text text-zinc-400">Needing Attention</p>
            </div>
        </div>

        <div class="sidebar-card">
            <!-- Drivers Card -->
            <drivers-chart-card />
        </div>

        <div class="sidebar-card">
            <!-- Total Scan -->
            <total-scans-card />
        </div>

        <div class="sidebar-card">
            <!-- Total Scan -->
            <exposures-card />
        </div>

        <div class="sidebar-card">
            <!-- detection  card -->
            <detection-rate-card />
        </div>

        <sidebar-logo class="mx-auto logo-sidebar cursor-pointer" />

    </div>
</template>

<script setup lang="ts">
import SidebarLogo from '~/assets/images/branding/sidebar-logo.svg';
import DetectionRateCard from '~/components/main/soc/sara/DetectionRateCard.vue';
import DriversChartCard from '~/components/main/soc/sara/DriversChartCard.vue';
import ExposuresCard from '~/components/main/soc/sara/ExposuresCard.vue';
import TotalScansCard from '~/components/main/soc/sara/TotalScansCard.vue';

import { useMobileStore } from '~/stores/layout/mobile';

const mobileStore = useMobileStore();
const route = useRoute();

const isMobile = ref(false);

// Check if we're on mobile/tablet
onMounted(() => {
    const checkMobile = () => {
        isMobile.value = window.innerWidth < 1025;
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    onUnmounted(() => {
        window.removeEventListener('resize', checkMobile);
    });
});

// Close mobile nav when route changes
watch(
    () => route.path,
    () => {
        if (isMobile.value) {
            mobileStore.closeMobileNav();
        }
    }
);

</script>

<style lang="scss">
.soc-sara-sidebar {
    @apply fixed top-0 right-0 z-100 w-80 h-full p-4 overflow-hidden overflow-y-auto transition-transform duration-300 ease-in-out flex flex-col;

    .sidebar-title h1 {
        @apply text-2xl font-bold text-white text-center mb-2;
    }
    .sub-heding-text{
        @apply text-xs text-zinc-50 leading-normal capitalize;
    }
    .number-text{
        @apply text-white text-3xl text-zinc-50 font-semibold leading-tight;
    }
    &.mobile-nav {
        background: #18181b;
        transform: translateX(100%);

        &.open {
            transform: translateX(0);
        }
    }
    .close-button {
        @apply bg-none border-none text-zinc-50 cursor-pointer absolute top-3 right-3;

        &:hover {
            @apply text-zinc-50;
        }
    }
    .sidebar-card {
        @apply bg-zinc-100 p-3 rounded-lg mb-2 border border-zinc-700 backdrop-blur flex flex-col gap-2;
    }
}
.update-title{
    @apply text-xs text-zinc-50 font-light flex gap-3 items-center;
}
.status-text{
    @apply text-sm leading-normal;
}
.graph-width{
    @apply w-52;
}
.logo-sidebar{
    @apply h-8 w-auto;
}
.number-medium-text{
    @apply text-2xl leading-tight font-semibold capitalize;
}
</style>

